export default function (time) {
  return function (result) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(JSON.parse(JSON.stringify(result)))
      }, time)
    })
  }
}
